import { render, staticRenderFns } from "./ManageZoneTable.vue?vue&type=template&id=6b999937&scoped=true&"
import script from "./ManageZoneTable.vue?vue&type=script&lang=js&"
export * from "./ManageZoneTable.vue?vue&type=script&lang=js&"
import style0 from "./ManageZoneTable.vue?vue&type=style&index=0&id=6b999937&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b999937",
  null
  
)

export default component.exports